import { Component, Input, OnInit, ViewChild, OnDestroy } from '@angular/core';
import { ComponentService } from '../../../services/component.service';
import { OverlayService } from '../../../services/overlay.service';
import { NgForm } from '@angular/forms';
import { Subscription } from 'rxjs';
import { tap, filter } from 'rxjs/operators';

@Component({
	selector: 'app-geo-targeted-images',
	templateUrl: './geo-targeted-images.component.html',
	styleUrls: ['./geo-targeted-images.component.scss']
})
export class GeoTargetedImagesComponent implements OnInit, OnDestroy {
	@Input() componentData: any;
	@Input() formHeight: string;
	@Input() pageType: string;
	@Input() componentID: number;
	@Input() urlGlobalRegExp: any;
	@ViewChild('geoTargetedForm', { static: true }) geoTargetedForm: NgForm;
	@ViewChild('nameField', { static: true }) nameField;
	geoTargetedFormSubscription: Subscription;

	constructor(private comService: ComponentService, private overlay: OverlayService) {}

	ngOnInit() {
		this.brodcastToPreview();
		this.geoTargetedFormSubscription = this.geoTargetedForm.valueChanges
			.pipe(
				tap(() => this.comService.updateDisabledSave(this.geoTargetedForm.invalid || this.nameField.editComponentName)),
				filter((form) => this.geoTargetedForm.dirty && this.geoTargetedForm.valid)
			)
			.subscribe();
	}

	ngOnDestroy() {
		this.geoTargetedFormSubscription.unsubscribe();
	}

	brodcastToPreview() {
		if (this.componentData.config.locations[0].link !== '') {
			this.componentData.config.locations[0].link_type = 'Custom';
		} else {
			this.componentData.config.locations[0].link_type = 'None';
		}

		this.comService.updateComponentData(this.componentData);
		this.comService.updatePreviewData();
	}

	addImage() {
		if (this.componentData.config.locations.length < 101) {
			this.componentData.config.locations.push({ image: '', link: '', tag: '' });
		} else {
			this.overlay.updateOverlay(true, 'You have reached the maximum Stores limit of 100 stores', 'alert');
		}
	}

	removeImage(index) {
		this.componentData.config.locations.splice(index, 1);
	}

	onLinkChange() {
		if (this.componentData.config.locations[0].link !== '') {
			this.componentData.config.locations[0].link_type = 'Custom';
		} else {
			this.componentData.config.locations[0].link_type = 'None';
		}
	}

	onAddressChange(event, index) {
		this.componentData.config.locations[index].lat = event.lat;
		this.componentData.config.locations[index].lng = event.lng;
		this.componentData.config.locations[index].address = event.address;
	}

	onNoRadiusChange(val) {
		this.componentData.config.no_radius = val;
		this.geoTargetedForm.controls['radius'].setValue(val ? 20 : this.componentData.config.radius);
	}
}
